import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useWorkflowStores } from "@/composables/workflowStores";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BoxSelectPreview',
    setup(__props) {
        const { toolbarStore } = useWorkflowStores();
        const cssVariables = computed(() => ({
            "--position-left": `${toolbarStore.boxSelectRect.x}px`,
            "--position-top": `${toolbarStore.boxSelectRect.y}px`,
            "--width": `${toolbarStore.boxSelectRect.width}px`,
            "--height": `${toolbarStore.boxSelectRect.height}px`,
        }));
        const visible = computed(() => toolbarStore.boxSelectRect.width !== 0 && toolbarStore.boxSelectRect.height !== 0);
        const removeMode = computed(() => toolbarStore.boxSelectMode === "remove");
        return { __sfc: true, toolbarStore, cssVariables, visible, removeMode };
    }
});
